import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetEventForm, setEventGaType } from "@store/eventForm/eventFormSlice";
import { gaEvent } from "@utils/gaEvent";

const Card = ({ item, ...props }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const location = useLocation()
    const isChinese = i18n.language === "hk";
    const memberInfoData = useSelector((state) => state.memberInfo.memberInfoData);
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get("type");

    const handleOnClick = () => {
        if (location.path === '/') {
            gaEvent(
                "clubs_homepage",
                "galaxy_ai_academy_detail",
                "galaxy_ai_academy_item",
                item.id
            );
            dispatch(setEventGaType(""));
        }
        else {
            if (type === "galaxy_ai_academy") {
                gaEvent(
                    "clubs_galaxy_ai_academy",
                    "galaxy_ai_academy_detail",
                    "galaxy_ai_academy_item",
                    item.id
                );
            }
            if (type === "event_registration") {
                gaEvent(
                    "clubs_experience",
                    "experience_detail",
                    "experience_item_1",
                    item.id
                );
            }
            dispatch(setEventGaType(type));
        }
        dispatch(resetEventForm());
        if (item.type == 1) {
            navigate(`/event_form?id=${item.id}`);
        }
        if (item.type == 2) {
            navigate(`/event_form?code=${item.campaign_code}`);
        }
        if (item.type == 3) {
            if (memberInfoData) {
                navigate(`/event_form?id=${item.id}`);
            } else {
                navigate(
                    `/login?redirect_url=/event_form?id=${item.id}`
                );
            }
        }
        if (item.type == 4) {
            navigate(`/event_form_access_code?id=${item.id}`);
        }
        if (item.type == 5) {
            navigate(`/workshop_video?id=${item.id}`);
        }
    }

    return (
        <Box
            className="card-container"
            onClick={handleOnClick}
        >
            <Box className="card-image-container">
                {item.type == 3 && (
                    <>
                        <Box className="card-gradient"> </Box>
                        <Box className="card-type">
                            <PeopleAltIcon className="type-icon" />
                            <Trans i18nKey="form:member_exclusive" />
                        </Box>
                    </>
                )}
                <Box className="card-label">
                    <img
                        className="card-image"
                        src={
                            isChinese ? item.thumbnail_hk : item.thumbnail_hk_en
                        }
                    />
                </Box>
            </Box>
            <Box className="detail-container">
                <Typography className="detail-title">
                    {isChinese ? item.title_hk : item.title_hk_en}
                </Typography>
                <Typography className="description">
                    {isChinese ? item.desc_hk : item.desc_hk_en}
                </Typography>{" "}
                <Box className="summary-button-container">
                    <Button className="summary-button">
                        <Trans i18nKey="form:register_now" />
                    </Button>
                </Box>
            </Box>
        </Box>
    )

}

export default Card;